import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_REQUEST_GUID from './GetRequestGuid.gql';

const parseResult = result => {
  const initialState = {};

  const requestGuid = get(result, 'core.getRequestGuid');

  return {
    ...initialState,
    ...requestGuid,
  };
};

export const useGetRequestGuid = options => {
  const [queryResult, queryAction] = useQuery(GET_REQUEST_GUID, {
    ...options,
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
